import { render, staticRenderFns } from "./PlanDataDetail.vue?vue&type=template&id=95405d5a&"
import script from "./PlanDataDetail.vue?vue&type=script&lang=js&"
export * from "./PlanDataDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports